import React, { useState } from 'react';
import { getIconForType } from './icons';

const HEADERS_DEFAULT = ['Name', 'Type', 'Description'];
const HEADERS_SEARCH = ['Name', 'Type', 'Description', 'Location'];

const ListView = ({ items, selectedId, onSelect, onDoubleClick, typeLabels, onContextMenu, onEmptyContextMenu, showLocationCol }) => {
  const HEADERS = showLocationCol ? HEADERS_SEARCH : HEADERS_DEFAULT;
  const [sortBy, setSortBy] = useState('Name');
  const [sortDir, setSortDir] = useState('asc');
  const [colWidths, setColWidths] = useState({ Name: 240, Type: 180, Description: 480, Location: 200 });

  const sorted = [...items].sort((a, b) => {
    const key = sortBy.toLowerCase();
    const av = key === 'type' ? (typeLabels[a.type] || a.type) : (a[key] || '');
    const bv = key === 'type' ? (typeLabels[b.type] || b.type) : (b[key] || '');
    const cmp = String(av).localeCompare(String(bv));
    return sortDir === 'asc' ? cmp : -cmp;
  });

  const handleSort = (col) => {
    if (sortBy === col) setSortDir(sortDir === 'asc' ? 'desc' : 'asc');
    else {
      setSortBy(col);
      setSortDir('asc');
    }
  };

  const startResize = (e, col) => {
    e.preventDefault();
    const startX = e.clientX;
    const startW = colWidths[col];
    const onMove = (ev) => {
      const w = Math.max(60, startW + (ev.clientX - startX));
      setColWidths((prev) => ({ ...prev, [col]: w }));
    };
    const onUp = () => {
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
    };
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
  };

  return (
    <div
      className="h-full w-full bg-white overflow-auto"
      style={{ fontFamily: 'Tahoma, Segoe UI, sans-serif' }}
      onContextMenu={(e) => {
        if (e.target === e.currentTarget && onEmptyContextMenu) onEmptyContextMenu(e);
      }}
    >
      {/* Column headers */}
      <div className="flex sticky top-0 z-10 bg-[#F0F0F0] border-b border-[#A0A0A0]" style={{ height: 22 }}>
        {HEADERS.map((h) => (
          <div
            key={h}
            className="relative flex items-center px-[6px] text-[12px] text-black border-r border-[#A0A0A0] hover:bg-[#E5E5E5] cursor-default"
            style={{ width: colWidths[h], minWidth: colWidths[h] }}
            onClick={() => handleSort(h)}
          >
            <span className="truncate">{h}</span>
            {sortBy === h && (
              <span className="ml-1 text-[10px]">{sortDir === 'asc' ? '▲' : '▼'}</span>
            )}
            <div
              onMouseDown={(e) => startResize(e, h)}
              className="absolute right-0 top-0 h-full w-[4px] cursor-col-resize"
            />
          </div>
        ))}
      </div>

      {/* Rows */}
      {sorted.length === 0 ? (
        <div className="p-4 text-[12px] text-gray-600">There are no items to show in this view.</div>
      ) : (
        sorted.map((item) => {
          const isSel = selectedId === item.id;
          return (
            <div
              key={item.id}
              data-list-row="1"
              onClick={() => onSelect(item.id)}
              onDoubleClick={() => onDoubleClick(item)}
              onContextMenu={(e) => onContextMenu && onContextMenu(e, item)}
              className={`flex h-[20px] cursor-default items-center text-[12px] ${
                isSel ? 'bg-[#316AC5] text-white' : 'hover:bg-[#E8F0FE] text-black'
              }`}
            >
              <div
                className="flex items-center px-[6px] truncate"
                style={{ width: colWidths['Name'], minWidth: colWidths['Name'] }}
              >
                <span className="mr-[4px] flex items-center flex-shrink-0">{getIconForType(item.type, 14)}</span>
                <span className="truncate">{item.name}</span>
              </div>
              <div
                className="px-[6px] truncate"
                style={{ width: colWidths['Type'], minWidth: colWidths['Type'] }}
              >
                {typeLabels[item.type] || item.type}
              </div>
              <div
                className="px-[6px] truncate"
                style={{ width: colWidths['Description'], minWidth: colWidths['Description'] }}
              >
                {item.description || ''}
              </div>
              {showLocationCol && (
                <div
                  className="px-[6px] truncate text-[#444]"
                  style={{ width: colWidths['Location'], minWidth: colWidths['Location'] }}
                >
                  philjustus.local/{item.parentName || ''}
                </div>
              )}
            </div>
          );
        })
      )}
    </div>
  );
};

export default ListView;
